import { stringify } from "query-string";
import { get, post } from "../../../services/httpClient";
import { formatPaymentData } from "./model";

export const getPayments = (
  filters: Record<string, string | number>,
  payload: {
    nationalIdentity: string;
  } | null,
) =>
  post<{ data: unknown }, typeof payload>(
    `payments?${stringify(filters, {
      skipEmptyString: true,
    })}`,
    payload,
  )
    .then((res) => res.data)
    .then(formatPaymentData);

export const refundPayment = (payload: {
  paymentId: number;
  amount?: number;
}) =>
  post<{ data: unknown }, typeof payload>("payments/refund", payload).then(
    (res) => res.data,
  );

export const getPaylogs = (paymentId: number) =>
  get<{ data: unknown }>(`payments/${paymentId}/paylog`).then(
    (res) => res.data,
  );
